import React, { useState } from "react";
import { Tabs, Tab } from "react-bootstrap";

function RecentTabs({ onTabSelect }) {
  const [selectedTab, setSelectedTab] = useState("Items");

  const handleTabSelect = (key) => {
    if (!key) return;
    setSelectedTab(key);
    onTabSelect(key);
  };

  return (
    <div className="profileTabs">
      <Tabs
        id="essentials-tabs"
        activeKey={selectedTab}
        onSelect={handleTabSelect}
        className="mb-3"
        justify
      >
        <Tab
          eventKey="Items"
          title={<span style={{ color: "#000" }}>Diet Item</span>}
        />
        <Tab
          eventKey="Totky"
          title={<span style={{ color: "#000" }}>Totkey</span>}
        />
        <Tab
          eventKey="BasicAppointment"
          title={<span style={{ color: "#000" }}>Appointments</span>}
        />
        {/* <Tab eventKey="EAppointment" title="Today E-Health Appointment" /> */}
      </Tabs>
    </div>
  );
}

export default RecentTabs;
